import axios from "axios";
import _ from "underscore";
import moment from "moment/moment";
import { message } from "antd";
import { isTrue } from "../service/service";
import { Moment } from "moment";
import qs from "qs";

/**
 * 活动时长文字
 * @param validityTime 分钟
 */
export function renderValidityTime(validityTime: number | undefined | null) {
    if (!validityTime) return "不限";
    if (validityTime > 60 * 24) return "超过一天";
    return `${validityTime}分钟`;
}

/**
 * 按长度截取字符串
 * @param str
 * @param len
 * @param dot
 */
export function strCut(str: string, len: number, dot: boolean = true) {
    return str.length > len ? str.substr(0, len) + (dot ? "..." : "") : str;
}

/**
 * html转换成纯文本
 * @param html
 * @param replaceFns
 */
export function htmlToPlain(
    html: string,
    ...replaceFns: ((html: string) => string)[]
) {
    const tempDivElement = document.createElement("div");
    let innerHTML = html;

    for (let fn of replaceFns) {
        innerHTML = fn(innerHTML);
    }

    tempDivElement.innerHTML = innerHTML;
    return tempDivElement.textContent || tempDivElement.innerText || "";
}

/**
 * 把html中图片标签替换成想要的内容
 */
export function replaceImgTag(html: string, replace: string = "[图片]") {
    return html.replaceAll(/<img [^>]*>/g, replace);
}

/**
 * 休眠 time毫秒
 * time: 毫秒
 */
export function sleep(time: number) {
    return new Promise(resolve => setTimeout(resolve, time));
}

/**
 * 加合
 * @param args
 */
export function sum(...args: number[]) {
    let num = 0;
    for (let i = 0; i < args.length; i++) {
        num += args[i];
    }
    return num;
}

/**
 * 索引数字转成A,B,C,D
 * @param index 数字, 从0开始
 */
export function indexToChar(index: number) {
    return String.fromCharCode(65 + index);
}

/**
 * 处理数字输入框输入的结果
 * @param totalScore 总分
 * @param score 设置的分数
 */
export function handleScore(totalScore: number, score: number) {
    const maxScore = Number(totalScore);

    //是特殊字符
    if (_.isNaN(Number(score))) return 0;

    //不是特殊字符
    if (!_.isUndefined(score) && score > maxScore) return maxScore;
    if (!_.isUndefined(score) && score < 0) return 0;
    return score;
}
/**
 * 下载文件的公共方法
 * @param method
 * @param url
 * @returns
 */
export const download = (method: "POST" | "GET", url: string) => {
    return axios({
        method,
        url,
        responseType: "blob"
    });
};

/**
 * 格式化时间
 */
export function FormatTime(time: string) {
    const currentTime = moment(); //当前时间
    const timeHandler = (days: number) => {
        return currentTime.clone().subtract(days, "days").startOf("day");
    };
    const yesterday = timeHandler(1);
    const inWeek = timeHandler(6);
    const isToday = moment(time).isSame(currentTime, "day");
    const isYesterday = moment(time).isSame(yesterday, "day");
    const isWithinAWeek = moment(time).isAfter(inWeek);

    let dataTime: string;
    switch (true) {
        case isToday:
            dataTime = moment(time).format("HH:mm");
            break;
        case isYesterday:
            dataTime = "昨天" + " " + moment(time).format("HH:mm");
            break;
        case isWithinAWeek:
            dataTime =
                moment(time).locale("zh-cn").format("dddd") +
                " " +
                moment(time).format("HH:mm");
            break;
        default:
            dataTime = moment(time).format("YY/MM/DD HH:mm");
    }
    return dataTime;
}

/**
 * 根据关键词截取字符串
 */

export function getStrBySlice(str: string, key: string, count: number) {
    //拿到关键字的索引，按照关键字的索引裁切字符串为三段
    const index = str?.indexOf(key);
    const firstWords = str?.slice(0, index);
    const lastWords = str?.slice(index + key.length);

    // 判断查询关键字是否是头尾
    const flag = !firstWords || !lastWords;

    const average = flag ? count : Math.floor((count - key.length) / 2);
    return {
        firstRest: firstWords?.length > average ? "..." : "",
        firstText: firstWords?.slice(-average),
        centerText: key,
        lastText: lastWords?.slice(0, average),
        lastRest: lastWords?.length > average ? "..." : ""
    };
}

export function stopJump(url: string, e?: any) {
    e?.preventDefault();
    e?.stopPropagation();
    const UrlStr = new URL(url);
    const Params = new URLSearchParams(UrlStr.search);
    const channelId = Params.get("channelId");
    if (!channelId || channelId?.length < 1) {
        return message.warn(
            "当前课程尚未创建直播频道，请联白果云系统管理员创建直播频道"
        );
    } else {
        window.open(url);
    }
}

/**
 * 把所有数据中包含的字符串, 清除两端空格
 * 注意: 该方法不会修改原对象的属性
 * @param data
 */
export function deepTrim<T>(data: T): T {
    if (data === null) return data;

    if (typeof data === "string") {
        return data.trim() as unknown as T;
    }

    if (Array.isArray(data)) {
        return data.map(item => deepTrim(item)) as unknown as T;
    }

    if (typeof data === "object") {
        const keys = Object.keys(data) as (keyof T)[];

        for (const key of keys) {
            data[key] = deepTrim(data[key]);
        }
        return data;
    }

    return data;
}

/**
 * 用来将checkbox的boolean值转成0/1
 */
export function getCheckBoxFieldProps() {
    return {
        getValueProps: (value: BooleanValue) => ({ checked: isTrue(value) }),
        getValueFromEvent: (e: any) =>
            typeof e === "boolean" ? e : e.target.checked ? "1" : "0"
    };
}

/**
 * 浏览器里过滤下拉列表的节点
 * @param inputValue
 * @param option
 */
export function filterOption(inputValue: string, option?: any) {
    inputValue = deepTrim(inputValue);
    return option?.props.children?.join("").indexOf(inputValue) !== -1;
}

/**
 * 校验富文本内容是否为空
 * @param text
 */
export function isEditorTextEmpty(text: string) {
    if (!text) return true;
    return text.trim() === "<p></p>";
}

/**
 * 时间转成友好表示形式
 * @param inputTime
 * @param compareTo
 */
export function getFriendlyTime(
    inputTime: string | Moment,
    compareTo?: string | Moment
) {
    return moment
        .duration(moment(inputTime).diff(moment(compareTo)))
        .humanize(true);
}

//课件类型
export const CourseWareTypeList = {
    ppt: ["ppt", "pptx"],
    word: ["doc", "docx"],
    excel: ["xls", "xlsx"],
    pdf: ["pdf"],
    href: ["html"],
    pic: ["png", "jpg", "jpeg", "gif"],
    txt: ["txt", "csv"],
    video: ["mp4", "mp3", "polyv"],
    polyv: ["polyv"],
    compression: ["rar", "7z", "zip"]
};

/**
 * 根据url猜文件名
 * @param url
 */
export function getFileName(url: string) {
    const queryParams = qs.parse(url.split("?").pop() || url, {
        ignoreQueryPrefix: true
    });
    const attname = (queryParams.attname as string) || "";
    if (attname) return attname;
    return url.split("/").pop() || "";
}
